import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

function Client() {
  const testimonials = [
    {
      text: "This inflatable dragon costume seemed perfect for Halloween! But upon inflating, it became clear the wings were uneven, causing me to spin uncontrollably like a rogue pool float.",
      author: "Rhodes Jhon",
      image:
        "https://html.pixelfit.agency/pesco/assets/images/testimonial/author-1.png",
      rating: 5,
    },
    {
      text: "This inflatable dragon costume seemed perfect for Halloween! But upon inflating, it became clear the wings were uneven, causing me to spin uncontrollably like a rogue pool float.",
      author: "Rhodes Jhon",
      image:
        "https://html.pixelfit.agency/pesco/assets/images/testimonial/author-2.png",
      rating: 5,
    },
    {
      text: "This inflatable dragon costume seemed perfect for Halloween! But upon inflating, it became clear the wings were uneven, causing me to spin uncontrollably like a rogue pool float.",
      author: "Rhodes Jhon",
      image:
        "https://html.pixelfit.agency/pesco/assets/images/testimonial/author-3.png",
      rating: 5,
    },
    {
      text: "This inflatable dragon costume seemed perfect for Halloween! But upon inflating, it became clear the wings were uneven, causing me to spin uncontrollably like a rogue pool float.",
      author: "Rhodes Jhon",
      image:
        "https://html.pixelfit.agency/pesco/assets/images/testimonial/author-4.png",
      rating: 5,
    },
  ];

  const { t } = useTranslation()
  // State to store number of slides to show
  const [slidesToShow, setSlidesToShow] = useState(2); // Default for desktop

  // Update the slidesToShow value based on window size
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setSlidesToShow(1); // Show 1 slide on mobile
    } else {
      setSlidesToShow(2); // Show 2 slides on desktop
    }
  };

  // Initialize slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: "16px", // spacing between cards on mobile
  };

  const sliderRef = useRef(null);

  useEffect(() => {
    // Set initial slidesToShow value
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {/* <section className="work-processing-section pt-80 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center mb-60 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="10"
                data-aos-duration="800"
              >
                <div className="sub-heading d-inline-flex align-items-center">
                  <i className="flaticon-sparkler"></i>
                  <span className="sub-title">Work Processing</span>
                  <i className="flaticon-sparkler"></i>
                </div>
                <h2 className="mb-3">How it Work processing</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-sm-6">
              <div
                className="iconic-box-item style-two mb-40 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="sn-number">01</div>
                <div className="icon">
                  <i className="fa fa-search"></i>
                </div>
                <div className="content">
                  <h6>Browsing &amp; Choosing</h6>
                  <p>
                    This is where customers visit your online store, browse your
                    products.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div
                className="iconic-box-item style-two mb-40 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="sn-number">02</div>
                <div className="icon">
                  <i className="fa fa-shopping-cart"></i>
                </div>
                <div className="content">
                  <h6>Checkout &amp; Payment</h6>
                  <p>
                    Once they have picked their items, customers proceed to
                    checkout.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div
                className="iconic-box-item style-two mb-40 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration="1400"
              >
                <div className="sn-number">03</div>
                <div className="icon">
                  <i className="fa fa-money-check-alt"></i>
                </div>
                <div className="content">
                  <h6>Order Fulfillment</h6>
                  <p>
                    After the order is placed, it's sent to your fulfillment
                    team.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div
                className="iconic-box-item style-two mb-40 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration="1600"
              >
                <div className="sn-number">04</div>
                <div className="icon">
                  <i className="fa fa-thumbs-up"></i>
                </div>
                <div className="content">
                  <h6>Delivery to Customer</h6>
                  <p>
                    The packed order is then sent off with a shipping carrier
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="py-3 py-md-5 py-xl-8">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div
                className="section-content-box mb-40 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-delay="30"
                data-aos-duration="800"
              >
                <div className="section-title mb-50">
                  <h2>{`${t('What_Our_Clients')}`}</h2>
                </div>

                <div className="testimonial-arrows style-one d-none d-lg-flex mt-3">
                  <div
                    className="prev slick-arrow"
                    onClick={() => sliderRef.current.slickPrev()}
                  >
                    <i className="fa fa-arrow-left"></i>
                  </div>
                  <div
                    className="next slick-arrow"
                    onClick={() => sliderRef.current.slickNext()}
                  >
                    <i className="fa fa-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonial Slider */}
            <div className="col-lg-8">
              <div
                className="testimonial-slider-one aos-init aos-animate"
                data-aos="fade-left"
                data-aos-delay="50"
                data-aos-duration="1000"
              >
                <Slider {...settings} ref={sliderRef}>
                  {testimonials.map((testimonial, index) => (
                    <div
                      key={index}
                      className="testimonial-item style-one mb-20"
                    >
                      <div className="testimonial-content">
                        <p className="mb-1 fs-6">{testimonial.text}</p>
                        <div className="author-quote-item d-flex justify-content-between align-items-center">
                          <div className="author-item">
                            <div className="author-thumb">
                              <img
                                src={testimonial.image}
                                alt={`${testimonial.author} image`}
                              />
                            </div>
                            <div className="author-info">
                              <h5>{testimonial.author}</h5>
                              <ul
                                className={`ratings rating${testimonial.rating}`}
                              >
                                {[...Array(testimonial.rating)].map((_, i) => (
                                  <li key={i}>
                                    <i className="fas fa-star"></i>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                          <div className="quote-icon">
                            <i className="flaticon flaticon-right-quote"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>

              <div className="testimonial-arrows style-one d-flax d-lg-none">
                <div
                  className="prev slick-arrow"
                  onClick={() => sliderRef.current.slickPrev()}
                >
                  <i className="fa fa-arrow-left"></i>
                </div>
                <div
                  className="next slick-arrow"
                  onClick={() => sliderRef.current.slickNext()}
                >
                  <i className="fa fa-arrow-right"></i>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>
    </>
  );
}

export default Client;
